import styled from "styled-components";
import { theme } from "./theme";

export const Title = styled.h1`
		font-weight: 500;
    font-size: 28px;
		text-align: center;
		line-height: 129%;
    color: ${theme.colors.black};
		margin: 0;
`

export const Subtitle = styled.h3`
		font-weight: 400;
		font-size: 16px;
		text-align: center;
    line-height: 150%;
    color: ${theme.colors.black};
    margin: 10px;
`
